import { Component, DestroyRef, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { Installation as InstallationService } from '../../Services/installation';
import { Graphe } from '../../Services/EntiteProjet';
import { GrapheCardComponent } from '../../Composants/graphe-card/graphe-card';

@Component({
  selector: 'app-graphiques',
  imports: [GrapheCardComponent],
  templateUrl: './graphiques.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './graphiques.css',
})
export class Graphiques {
  private route = inject(ActivatedRoute);
  private installationService = inject(InstallationService);
  private destroyRef = inject(DestroyRef);
  private requeteId = 0;

  installationId = toSignal(
    this.route.paramMap.pipe(map((p) => (p.has('id') ? Number(p.get('id')) : null))),
    { initialValue: null },
  );

  chargement = signal(false);
  erreur = signal<string | null>(null);
  graphes = signal<Graphe[] | null>(null);

  constructor() {
    this.route.paramMap
      .pipe(
        map((p) => (p.has('id') ? Number(p.get('id')) : null)),
        takeUntilDestroyed(),
      )
      .subscribe((id) => {
        const requete = ++this.requeteId;
        const estValide = () => requete === this.requeteId && !this.destroyRef.destroyed;
        this.graphes.set(null);
        this.erreur.set(null);
        this.chargement.set(false);
        if (!id) return;
        this.chargement.set(true);
        void this.installationService
          .getGraphes(id)
          .then((res) => {
            if (!estValide()) return;
            this.graphes.set(res);
            this.chargement.set(false);
          })
          .catch((err: unknown) => {
            if (!estValide()) return;
            this.erreur.set((err as Error)?.message ?? 'Erreur de chargement');
            this.chargement.set(false);
          });
      });
  }
}
